export const environment = {
  NAME: "PROD",
  ANALYTICS_ENABLED: true,
  WEB_BASE_URL: "https://webapp.aiball.io",
  API_BASE_URL: "https://api.aiball.io",
  // Assistance chat lives on a separate async host (not the main API).
  // Currently the same for prod and dev; dev/localhost will likely get their
  // own host later — override CHAT_API_BASE_URL in those environment files.
  CHAT_API_BASE_URL: "https://asyncaiball.arcvi.io",
  FIREBASE_CONFIG: {
    apiKey: "AIzaSyBaj_6ci6jdZWJaXVbscylXvc6kWvG85Ro",
    authDomain: "arcvi-aiball.firebaseapp.com",
    projectId: "arcvi-aiball",
    storageBucket: "arcvi-aiball.appspot.com",
    messagingSenderId: "653396675245",
    appId: "1:653396675245:web:3fe3ad09bca53038a55424",
    measurementId: "G-FL59PHRH4J",
  },
  ONE_SIGNAL_ID: "bb5553a3-0e60-4fc5-a21b-6eac082339a9",
  PLAY_STORE_URL:
    "https://play.google.com/store/apps/details?id=io.aiball.aiball",
  APP_STORE_URL: "https://apps.apple.com/us/app/aiball/id6450213118",
  SOCIAL: {
    INSTAGRAM_URL: "https://www.instagram.com/aiball_oficial/",
  },
  // Enable or disable wallet feature
  IS_WALLET_ENABLED: false,
  // Google Maps API key (used by the Community map view).
  // Native platforms also need the key configured in AndroidManifest.xml and AppDelegate.swift.
  GOOGLE_MAPS_API_KEY: "",
};
